import ThreeSixtyGreyLogo from '../assets/images/360pay-grey-logo.png';
import CabieICSTwoLogo from '../assets/images/ics2-logo.png';
import ThreeSixtyBanner from '../assets/images/360pay-banner.jpg';

export default function MaintenancePage(props) {
  return (
    <div className="maintenance-container">
      <div className="maintenance-logo-group">
        <div>
          <img src={ThreeSixtyGreyLogo} alt="360pay-logo" className="maintenance-logo" />
        </div>
        <span className="maintenance-powered-by">Powered&nbsp;By</span>
        <div>
          <img src={CabieICSTwoLogo} alt="Cabie-Logo" className="maintenance-logo" />
        </div>
      </div>
      <div className="maintenance-message-box">
        <h1>We'll be back soon!</h1>
        <p>
          ICS2 is currently undergoing scheduled maintenance.
          <br />
          Thank you for your patience.
        </p>
        <p className="maintenance-contact-text">
          For any urgent enquiries, please contact us at <a href="mailto:ICS2Support@eori.uk">ICS2Support@eori.uk</a>
        </p>
      </div>
      <div className="maintenance-images">
        <img src={ThreeSixtyBanner} alt="360pay" className="maintenance-img-360" />
      </div>
    </div>
  );
}
